import React from 'react';
import { StyleSheetManager } from 'styled-components';
import { ConfigProvider } from 'antd';
import plPL from 'antd/locale/pl_PL';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

dayjs.locale('pl');

const appTheme = {
  token: {
    colorPrimary: '#f97316',
    colorInfo: '#1677ff',
    colorBgLayout: '#f3f4f6',
    colorBgContainer: '#ffffff',
    colorText: '#101828',
    colorTextSecondary: '#667085',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f0f0f0',
    borderRadius: 7,
    borderRadiusLG: 8,
    borderRadiusSM: 5,
    controlHeight: 30,
    controlHeightSM: 24,
    controlHeightLG: 34,
    fontFamily: "'Roboto', sans-serif",
    fontSize: 13,
    lineHeight: 1.45,
    margin: 10,
    marginXS: 4,
    marginSM: 6,
    marginMD: 10,
    padding: 10,
    paddingXS: 4,
    paddingSM: 6,
    paddingMD: 10,
    boxShadow: '0 1px 4px rgba(15, 23, 42, 0.06)',
    boxShadowSecondary: '0 8px 24px rgba(15, 23, 42, 0.1)',
  },
  components: {
    Button: {
      borderRadius: 7,
      controlHeight: 30,
      controlHeightSM: 24,
      paddingInline: 10,
      paddingInlineSM: 7,
      primaryShadow: 'none',
    },
    Card: {
      borderRadiusLG: 8,
      headerHeight: 38,
      paddingLG: 12,
      padding: 12,
      paddingSM: 10,
    },
    Table: {
      borderColor: '#eef0f3',
      cellFontSize: 12,
      cellPaddingBlock: 6,
      cellPaddingInline: 8,
      cellPaddingBlockSM: 5,
      cellPaddingInlineSM: 7,
      headerBg: '#f8fafc',
      headerColor: '#344054',
      headerSplitColor: '#e5e7eb',
      rowHoverBg: '#fff7ed',
    },
    Form: {
      itemMarginBottom: 8,
      labelColor: '#344054',
      labelFontSize: 12,
      verticalLabelPadding: '0 0 3px',
    },
    Input: {
      borderRadius: 7,
      controlHeight: 30,
      controlHeightSM: 24,
    },
    InputNumber: {
      borderRadius: 7,
      controlHeight: 30,
      controlHeightSM: 24,
    },
    Select: {
      borderRadius: 7,
      controlHeight: 30,
      controlHeightSM: 24,
      optionSelectedBg: '#fff7ed',
    },
    DatePicker: {
      borderRadius: 7,
      controlHeight: 30,
      controlHeightSM: 24,
    },
    Modal: {
      borderRadiusLG: 8,
      contentBg: '#ffffff',
      headerBg: '#ffffff',
      titleFontSize: 15,
      padding: 18,
      paddingContentHorizontalLG: 18,
      paddingContentVerticalLG: 18,
    },
    Tabs: {
      horizontalMargin: '0 0 8px 0',
      itemSelectedColor: '#f97316',
      inkBarColor: '#f97316',
    },
    Tag: {
      borderRadiusSM: 6,
      defaultBg: '#f8fafc',
    },
    Dropdown: {
      borderRadiusLG: 8,
    },
    Popover: {
      borderRadiusLG: 8,
    },
  },
};

const StyleProvider = ({ children }) => {
  return (
    <StyleSheetManager disableVendorPrefixes={false}>
      <ConfigProvider locale={plPL} theme={appTheme} componentSize="middle">
        {children}
      </ConfigProvider>
    </StyleSheetManager>
  );
};

export default StyleProvider;
